export default "__VITE_ASSET__43767a84__"